import { useCallback, useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import { BigNumber, providers } from 'ethers';

export const useEthBalance = () => {
  const [balance, setBalance] = useState<BigNumber>(BigNumber.from(0));

  const { account, chainId, connector } = useWeb3React();

  const fetchBalance = useCallback(async () => {
    if (!account) return;
    if (!chainId) return;
    try{
      const provider = new providers.Web3Provider(connector.provider!);
      const rawBalance = await provider.getBalance(account);
      setBalance(rawBalance);
    }
    catch(err){
      console.log(err)
    }
  }, [account, chainId, connector]);

  useEffect(() => {
    fetchBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, chainId]);

  useEffect(() => {
    fetchBalance();

    setTimeout(() => {
      fetchBalance();
    }, 30000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return balance;
};
